export class DriftProtectionTimePoint {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "date",
            "baseName": "date",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "policies",
            "baseName": "policies",
            "type": "Array<DriftProtectionPolicy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DriftProtectionTimePoint.attributeTypeMap;
    }
    constructor() {
    }
}
